module.exports = __webpack_public_path__ + "img/airplane.37066772.jpg";